import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

import { selectActiveVenueId, selectMsInventoryVenues } from 'selectors/general';
import { selectInstructor, selectIsInstructorLoading } from '../Instructors.selectors';
import InstructorDetails from './InstructorDetails';

const getVenueLocationsByIds = (venues, instructorVenueIds) =>
  _isEmpty(instructorVenueIds)
    ? []
    : instructorVenueIds.reduce((instructorVenueAddresses, venueId) => {
        const venue = venues.find(item => venueId === item.id);
        return !venue ? instructorVenueAddresses : instructorVenueAddresses.concat(venue);
      }, []);

const getInstagramService = socialHandles =>
  !_isEmpty(socialHandles) ? socialHandles.find(element => element.service === 'instagram') : { userName: '' };

export function mapStateToProps(state, ownProps) {
  const { instructorId, ...restOwnProps } = ownProps;
  const venueId = selectActiveVenueId(state);

  return {
    instructor: selectInstructor(state, instructorId),
    isLoading: selectIsInstructorLoading(state, instructorId),
    venues: selectMsInventoryVenues(state),
    venueId,
    ...restOwnProps,
  };
}

export const mergeProps = (stateProps, dispatchProps) => {
  const {
    instructor: { socialHandles, venueIds },
    venues,
  } = stateProps;

  return {
    instagramService: getInstagramService(socialHandles),
    instructorVenues: getVenueLocationsByIds(venues, venueIds),
    ...stateProps,
    ...dispatchProps,
  };
};

export default connect(mapStateToProps, null, mergeProps)(InstructorDetails);
